import { CalendarPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/lib/api";

const stamp = (date, time, addH = 0) => {
  const [y, m, d] = date.split("-").map(Number);
  const [hh, mm] = (time || "09:00").split(":").map(Number);
  const t = new Date(Date.UTC(y, m - 1, d, hh + addH, mm));
  return t.toISOString().slice(0, 19).replace(/[-:]/g, "");
};

const googleUrl = (ev) => {
  const end = ev.end_time ? stamp(ev.date, ev.end_time) : stamp(ev.date, ev.start_time, 2);
  const p = new URLSearchParams({
    action: "TEMPLATE", text: ev.title, dates: `${stamp(ev.date, ev.start_time)}/${end}`, ctz: "Asia/Manila",
    location: ev.location || "Victory Parañaque, 3rd Level, Bldg B, SM Sucat, Parañaque City",
    details: `${ev.description || ""}\n${window.location.origin}/events/${ev.id}`.trim(),
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};

export const AddToCalendar = ({ ev }) => (
  <div className="flex flex-wrap gap-2" data-testid="add-to-calendar">
    <Button asChild size="sm" variant="outline" className="rounded-full" data-testid="add-to-apple-calendar">
      <a href={`${API}/public/events/${ev.id}/calendar.ics`}><CalendarPlus className="mr-1 h-4 w-4" /> iPhone / Apple Calendar</a>
    </Button>
    <Button asChild size="sm" variant="outline" className="rounded-full" data-testid="add-to-google-calendar">
      <a href={googleUrl(ev)} target="_blank" rel="noreferrer"><CalendarPlus className="mr-1 h-4 w-4" /> Google Calendar</a>
    </Button>
  </div>
);
